import React,{Component} from 'react';
import TextField from "@material-ui/core/TextField";
import { Link } from 'react-router-dom';
import SimpleReactValidator from "simple-react-validator";
import Api from "../../../libraries/api";
import Button from '@material-ui/core/Button';
import ErrorHandling from "../../../libraries/error-handling";
import {toast, ToastContainer} from "react-toastify";
import {history} from "../../../shared/configure-store";
import AuthHelper from "../../../libraries/auth-helper";

require('dotenv').config();
const validator = new SimpleReactValidator({locale: process.env.REACT_APP_LOCALE});

class EditCategory extends Component {
    constructor(props) {

        super(props);

        this.state = {
            loading: true,
            loadingButton: false,
            errors: {},

            id: '',
            name: '',
            description: '',
            active: false,

            isManage: false,
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {

        document.title = 'Gudangemas - Ubah Kategori';

        const id = this.props.match.params.id;

        let profile = AuthHelper.getProfile();
        if(profile['map-menu']) {
            let roles = profile['map-menu'].map(o => {
                return {
                    id: o.id,
                    name: o.menu.name,
                    isCreate: o.isCreate,
                    isManage: o.isManage,
                }
            });

            let all = roles.filter((item) => item.name === 'Blog');

            if (all.length > 0) {
                this.setState({
                    isManage: all[0] ? all[0].isManage : false
                });
            }
        }

        Api.get('/blog-page/get-category-by-id/'+id).then(resp => {

            if (resp.data) {

                this.setState({
                    id: id,
                    name: resp.data.name,
                    description: resp.data.description,
                    active: resp.data['is-active'],
                    loading: false
                    }
                );
            }

        }).catch(err => {
            console.log(err);
        });
    }

    handleChange (e, prop){

        this.setState({

            [prop]: e.target.value

        })

    };

    showMessage = (status, message) => {
        if(status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };

    handleSubmit = (e) => {

        e.preventDefault();

        if (!validator.allValid()) {

            this.setState({
                    errors: validator.getErrorMessages()
                }
            );

            return false;

        }

        this.setState({
                errors: {},
                loadingButton: true,
            }
        );

        let params = {
            'id': this.state.id,
            'name': this.state.name,
            'description': this.state.description,
            'is-active': true,
            'is-blog': true,
        };


        Api.put('/blog-page/category', params).then(resp => {

            if(resp.status === 200) {
                history.push('/blogs-categories');
                this.showMessage(true, 'Kategori berhasil diubah');
            }else {
                this.showMessage(false, resp.message[0]);
            }
            this.setState({
                    loadingButton: false,
                }
            );

        }).catch(err => {

            if(ErrorHandling.checkErrorTokenExpired(err)){

            }else{

                this.setState({
                        errors: err.errors,
                        loadingButton: false
                    }
                );

                this.showMessage(false, 'Invalid format data');
            }
        });


    };

    handleGo  = (link) => {

        history.push(link);
    };

    getBase64(file, cb) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result)
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }


    render() {
        return (
            <div className="row main-content">
                <div className="col-12">
                    <h1 className="page-title">Kategori</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/blogs-categories" >Kategori</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Ubah</li>
                        </ol>
                    </nav>

                </div>
                <div className="col-12">
                    <div className="table-wrapper">
                        <div className="row align-items-center content-title">
                            <div className="col-6">
                                <h2 className='mb-0'>Ubah Kategori</h2>
                            </div>
                        </div>
                        <h3 className='section-title'> </h3>

                        <form name="category" id="editCategory" className="row" noValidate>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Nama</label>
                                    <TextField variant="outlined"
                                               type='text'
                                               id='name'
                                               name="name"
                                               label="Nama"
                                               onChange={(e) => this.handleChange(e, 'name')}
                                               value={this.state.name}
                                               fullWidth
                                    />
                                    {validator.message('name', this.state.name, 'required')}
                                    <div className='text-danger'>{this.state.errors.name}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Deskripsi</label>
                                    <TextField variant="outlined"
                                               type='text'
                                               id='description'
                                               name="description"
                                               label="Deskripsi"
                                               onChange={(e) => this.handleChange(e, 'description')}
                                               value={this.state.description}
                                               fullWidth
                                    />
                                    <div className='text-danger'>{this.state.errors.description}</div>
                                </div>
                            </div>
                            {/*<div className="col-md-6">
                                <div className="form-group">
                                    <label>Active</label>
                                    <FormGroup className='mb-3 label-tnc'>
                                        <FormControlLabel
                                            color="primary"
                                            control={<Checkbox
                                                checked={this.state.active}
                                                onChange={() => this.handleChecked('active')}
                                                value={true}
                                            />}
                                            label='Active'
                                            className="mb-0"
                                        />
                                    </FormGroup>
                                    <div className='text-danger'>{this.state.errors.active}</div>
                                </div>
                            </div>*/}

                            <div className="col-12 text-center">
                                <Button
                                    className="mr-3"
                                    variant="contained"
                                    onClick={() => this.handleGo('/blogs-categories')}
                                >
                                    Batal
                                </Button>
                                {this.state.isManage &&
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.handleSubmit}
                                    disabled={this.state.loadingButton}
                                >
                                    Simpan { this.state.loadingButton && <i className="fa fa-spinner fa-spin"> </i> }
                                </Button>
                                }


                            </div>
                        </form>
                    </div>

                </div>
                <ToastContainer />

            </div>
        )
    }
}

export default EditCategory;
